export class Screen {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly path: string,
  ) {}
}

export class RoleEnum {
  static readonly PROFILES: Screen = new Screen(80, 'Perfis', '/profiles');
  static readonly SCREENS: Screen = new Screen(81, 'Telas', '/screens');
  static readonly CONTRACTS: Screen = new Screen(82, 'Contratos', '/contracts');
  static readonly MODULES: Screen = new Screen(83, 'Módulos', '/modules');
  static readonly USERS: Screen = new Screen(84, 'Usuários', '/users');

  static values(): Screen[] {
    return [
      RoleEnum.PROFILES,
      RoleEnum.SCREENS,
      RoleEnum.CONTRACTS,
      RoleEnum.MODULES,
      RoleEnum.USERS
    ];
  }
}
